// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1dgLa","title":"Info_title__mkFi_","selects":"Info_selects__38LS3","requiredAsterisk":"Info_requiredAsterisk__3yUbF"};